import React from 'react';
import { FileText, AlertCircle, CheckCircle2 } from 'lucide-react';

const TermsOfServicePage = () => {
  return (
    <div className="dark-page legal-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="display-huge page-title">Terms of Service</h1>
          <p className="body-large page-subtitle">
            Last Updated: January 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content-section">
        <div className="legal-container">
          
          <div className="legal-section">
            <h2 className="legal-heading">Agreement to Terms</h2>
            <p className="legal-text">
              These Terms of Service constitute a legally binding agreement made between you and The Collins Academy ("Company," "we," "us," or "our"), concerning your access to and use of our website and services. You agree that by accessing the site and/or services, you have read, understood, and agree to be bound by all of these Terms of Service. If you do not agree with all of these terms, then you are expressly prohibited from using the site and services and you must discontinue use immediately.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Services Description</h2>
            <p className="legal-text">
              The Collins Academy provides financial education, credit optimization guidance, business formation assistance, tradeline services, and related consulting services. Our services are designed to help clients improve their financial structure and position themselves for funding opportunities.
            </p>
            <p className="legal-text">
              <strong>Important:</strong> We are not a law firm, accounting firm, or licensed financial advisor. Our services are educational and consultative in nature. We do not guarantee specific credit score improvements, loan approvals, or funding outcomes as individual results may vary based on numerous factors.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">User Representations</h2>
            <p className="legal-text">By using our services, you represent and warrant that:</p>
            <ul className="legal-list">
              <li>You are at least 18 years of age</li>
              <li>You have the legal capacity to enter into these Terms of Service</li>
              <li>All information you provide is true, accurate, current, and complete</li>
              <li>You will maintain the accuracy of such information</li>
              <li>Your use of our services will not violate any applicable law or regulation</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Payment Terms</h2>
            <p className="legal-text">
              Payment for services is due at the time of purchase unless otherwise agreed upon in writing. All payments are processed through secure third-party payment processors. Prices for our services are subject to change without notice. You agree to provide current, complete, and accurate purchase and account information for all purchases made.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Refund Policy</h2>
            <p className="legal-text">
              Due to the nature of our services, refunds are handled on a case-by-case basis. If you are unsatisfied with our services, please contact us within 30 days of purchase to discuss your concerns. We are committed to ensuring client satisfaction and will work with you to address any issues.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Prohibited Activities</h2>
            <p className="legal-text">You may not use our services for any purpose that is unlawful or prohibited by these Terms. You agree not to:</p>
            <ul className="legal-list">
              <li>Provide false or misleading information</li>
              <li>Use our services for any fraudulent purpose</li>
              <li>Interfere with or circumvent our security features</li>
              <li>Engage in any activity that could damage or impair our services</li>
              <li>Use our services in any manner that could be considered harassment</li>
              <li>Attempt to impersonate another user or person</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Intellectual Property</h2>
            <p className="legal-text">
              The content on our website, including text, graphics, logos, images, and software, is the property of The Collins Academy and is protected by copyright and trademark laws. You may not reproduce, distribute, modify, or create derivative works from any content without our express written permission.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Disclaimer of Warranties</h2>
            <p className="legal-text">
              OUR SERVICES ARE PROVIDED ON AN "AS-IS" AND "AS-AVAILABLE" BASIS. YOU AGREE THAT YOUR USE OF OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Limitation of Liability</h2>
            <p className="legal-text">
              IN NO EVENT SHALL THE COLLINS ACADEMY, ITS DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF OUR SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Governing Law</h2>
            <p className="legal-text">
              These Terms shall be governed by and defined following the laws of the United States. The Collins Academy and yourself irrevocably consent that the courts shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these terms.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Contact Us</h2>
            <p className="legal-text">
              If you have questions or comments about these Terms of Service, please contact us at:
            </p>
            <p className="legal-text">
              <strong>The Collins Academy</strong><br />
              Email: information@thecollinsacademy.com<br />
              Phone: (800) 555-0199
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default TermsOfServicePage;
